import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { publicApi } from "@/lib/api";

const SiteContext = createContext(null);
export const useSite = () => useContext(SiteContext);

const EMPTY = { featured: null, music: [], upcoming: [], videos: [], merch: [], pages: {}, links: {} };

export const SiteProvider = ({ children }) => {
  const [data, setData] = useState(EMPTY);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(() => {
    publicApi.get("/public/site")
      .then((r) => setData({ ...EMPTY, ...r.data }))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <SiteContext.Provider value={{ ...data, loading, refresh }}>{children}</SiteContext.Provider>;
};
